import React from "react";
import { Badge } from "@mantine/core";

interface Props {
  status:
    | "connected"
    | "disconnected"
    | "error"
    | "unknown"
    | "online"
    | "offline";
}

const statusConfig: Record<string, { color: string; label: string }> = {
  connected: { color: "green", label: "Connected" },
  online: { color: "green", label: "Online" },
  disconnected: { color: "red", label: "Disconnected" },
  offline: { color: "red", label: "Offline" },
  error: { color: "yellow", label: "Error" },
  unknown: { color: "gray", label: "Unknown" },
};

const DeviceStatusBadge: React.FC<Props> = ({ status }) => {
  const config = statusConfig[status] || statusConfig.unknown;
  return (
    <Badge color={config.color} variant="filled" size="sm">
      {config.label}
    </Badge>
  );
};

export default DeviceStatusBadge;
